import React, { FC } from 'react'
import { Box, Button, Typography, Stack } from '@mui/material'
import { TextareaAutosize } from '@mui/material'

interface NewsContentFieldsProps {
  description: string
  body: string
  editingId: string | null
  isSubmitting: boolean
  onDescriptionChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onBodyChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onReset: () => void
}

const NewsContentFields: FC<NewsContentFieldsProps> = ({
  description,
  body,
  editingId,
  isSubmitting,
  onDescriptionChange,
  onBodyChange,
  onReset,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Stack spacing={3} sx={{ flex: 1 }}>
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Descripción <Box component="span" sx={{ color: 'error.main' }}>*</Box>
          </Typography>
          <TextareaAutosize
            minRows={4}
            value={description}
            onChange={onDescriptionChange}
            required
            onInvalid={(e) => {
              (e.target as HTMLTextAreaElement).setCustomValidity('Por favor completa este campo')
            }}
            onInput={(e) => {
              (e.target as HTMLTextAreaElement).setCustomValidity('')
            }}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '4px',
              border: '1px solid #e0e0e0',
              fontFamily: 'inherit',
              fontSize: '14px',
              resize: 'none',
              boxSizing: 'border-box',
            }}
          />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Contenido <Box component="span" sx={{ color: 'error.main' }}>*</Box>
          </Typography>
          <TextareaAutosize
            minRows={10}
            value={body}
            onChange={onBodyChange}
            required
            onInvalid={(e) => {
              (e.target as HTMLTextAreaElement).setCustomValidity('Por favor completa este campo')
            }}
            onInput={(e) => {
              (e.target as HTMLTextAreaElement).setCustomValidity('')
            }}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '4px',
              border: '1px solid #e0e0e0',
              fontFamily: 'inherit',
              fontSize: '14px',
              resize: 'none',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
            }}
          />
        </Box>
      </Stack>

      {/* Action Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6, gap: 4 }}>
        {editingId && (
          <Button
            variant="outlined"
            onClick={onReset}
            disabled={isSubmitting}
            sx={{
              textTransform: 'none',
              px: 4,
              py: 1.2,
              fontSize: '14px',
              color: '#6b7280',
              borderColor: '#d1d5db',
              '&:hover': {
                borderColor: '#9ca3af',
                backgroundColor: '#f9fafb',
              },
            }}
          >
            Cancelar
          </Button>
        )}
        <Button
          type="submit"
          variant="contained"
          disabled={isSubmitting}
          sx={{
            backgroundColor: '#1e3a5f',
            textTransform: 'none',
            px: 6,
            py: 1.2,
            fontSize: '14px',
            '&:hover': {
              backgroundColor: '#152a45',
            },
          }}
        >
          {editingId ? 'Actualizar' : 'Agregar'}
        </Button>
      </Box>
    </Box>
  )
}

export default NewsContentFields
